import type { ReactNode } from 'react';
import { cn } from './utils';
import { PinToggle } from './PinToggle';

/**
 * DESIGN.md's Two-Line Header Rule: a semibold title, a muted subtitle one
 * line below, and right-aligned actions on the same row.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  /** SIL-364: this page's own nav route — renders a Pin/Pinned toggle
   * before `actions` when set. Omit for pages that aren't in CUSTOMER_NAV. */
  pinTo,
  className,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  pinTo?: string;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-3', className)}>
      <div>
        <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        {subtitle && <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {(pinTo || actions) && (
        <div className="flex items-center gap-2">
          {pinTo && <PinToggle to={pinTo} label={title} />}
          {actions}
        </div>
      )}
    </div>
  );
}
